import React, { useState } from "react";
import * as S from "./styled";
import HeaderLogo from "../../../assets/images/header/header-logo.png";
import { NavLink, useLocation } from "react-router-dom";
import Icon from "../../Icon";

const Header = () => {
  const { pathname } = useLocation();

  const [isMobNavOpen, setIsMobNavOpen] = useState<boolean>(false);

  return (
    <S.HeaderComponent className="main-header">
      <div className="inner">
        <S.HeaderContainer>
          <NavLink to="/">
            <S.HeaderLogo className="header-logo">
              <Icon>
                <img src={HeaderLogo} alt="logo" />
              </Icon>
            </S.HeaderLogo>
          </NavLink>
          <S.HeaderNav>
            <ul>
              <li className={`${pathname === "/instructors" ? "active" : ""}`}>
                <NavLink to="/instructors">강사진</NavLink>
              </li>
              <li className={`${pathname === "/schedule" ? "active" : ""}`}>
                <NavLink to="/schedule">시간표</NavLink>
              </li>
              <li className={`${pathname === "/video" ? "active" : ""}`}>
                {/* <NavLink to="/video">수업영상</NavLink> */}
                <NavLink
                  to="https://youtube.com/@neptunedance?si=84x62lK9PCpUX4FZ"
                  target="_blank"
                >
                  수업영상
                </NavLink>
              </li>
              <li className={`${pathname === "/pricingClass" ? "active" : ""}`}>
                <NavLink to="/pricingClass">수강료&수업소개</NavLink>
              </li>
              <li className={`${pathname === "/shuffle" ? "active" : ""}`}>
                <NavLink to="/shuffle">셔플</NavLink>
              </li>
              <li className={`${pathname === "/training" ? "active" : ""}`}>
                <NavLink to="/training">전문인 양성과정</NavLink>
              </li>
              <li className={`${pathname === "/contactus" ? "active" : ""}`}>
                <NavLink to="/contactus">상담/문의</NavLink>
              </li>
            </ul>
            <div>
              <NavLink
                to="https://smartstore.naver.com/neptunedance"
                target="_blank"
              >
                SHOP
              </NavLink>
            </div>
          </S.HeaderNav>
          {/* S ::: Mobile ::: S */}
          <S.HeaderHamBugerWrap
            onClick={() => setIsMobNavOpen((prev) => !prev)}
            className={isMobNavOpen ? "active" : ""}
          >
            <span></span>
            <span></span>
            <span></span>
          </S.HeaderHamBugerWrap>
          {/* E ::: Mobile ::: E */}
        </S.HeaderContainer>
      </div>

      {/* S ::: Mobile ::: S */}
      <S.HeaderMobNavDim
        className={isMobNavOpen ? "active" : ""}
        onClick={() => setIsMobNavOpen((prev) => !prev)}
      />
      <S.HeaderMobNavWrap className={isMobNavOpen ? "active" : ""}>
        <S.HeaderMobNavContentsWrap>
          <S.HeaderMobLogo>
            <Icon>
              <img src={HeaderLogo} alt="logo" />
            </Icon>
          </S.HeaderMobLogo>
          <S.HeaderMobNav>
            <ul>
              <li className={`${pathname === "/instructors" ? "active" : ""}`}>
                <NavLink
                  to="/instructors"
                  onClick={() => setIsMobNavOpen(false)}
                >
                  강사진
                </NavLink>
              </li>
              <li className={`${pathname === "/schedule" ? "active" : ""}`}>
                <NavLink to="/schedule" onClick={() => setIsMobNavOpen(false)}>
                  시간표
                </NavLink>
              </li>
              <li className={`${pathname === "/video" ? "active" : ""}`}>
                {/* <NavLink to="/video" onClick={() => setIsMobNavOpen(false)}>
                  수업영상
                </NavLink> */}
                <NavLink
                  to="https://youtube.com/@neptunedance?si=84x62lK9PCpUX4FZ"
                  target="_blank"
                  onClick={() => setIsMobNavOpen(false)}
                >
                  수업영상
                </NavLink>
              </li>
              <li className={`${pathname === "/pricingClass" ? "active" : ""}`}>
                <NavLink
                  to="/pricingClass"
                  onClick={() => setIsMobNavOpen(false)}
                >
                  수강료&수업소개
                </NavLink>
              </li>
              <li className={`${pathname === "/shuffle" ? "active" : ""}`}>
                <NavLink to="/shuffle" onClick={() => setIsMobNavOpen(false)}>
                  셔플
                </NavLink>
              </li>
              <li className={`${pathname === "/training" ? "active" : ""}`}>
                <NavLink to="/training" onClick={() => setIsMobNavOpen(false)}>
                  전문인 양성과정
                </NavLink>
              </li>
              <li className={`${pathname === "/contactus" ? "active" : ""}`}>
                <NavLink to="/contactus" onClick={() => setIsMobNavOpen(false)}>
                  상담/문의
                </NavLink>
              </li>
            </ul>
            <div>
              <NavLink
                to="https://smartstore.naver.com/neptunedance"
                target="_blank"
              >
                SHOP
              </NavLink>
            </div>
          </S.HeaderMobNav>
        </S.HeaderMobNavContentsWrap>
      </S.HeaderMobNavWrap>
      {/* E ::: Mobile ::: E */}
    </S.HeaderComponent>
  );
};

export default Header;
